<div *transloco="let t" class="drawer lg:drawer-open h-full">
  <input id="my-drawer-2" type="checkbox" class="drawer-toggle" />

  <div class="drawer-content flex flex-col h-full">
    <div
      class="navbar min-h-14 h-14 bg-surface border-b border-border-default lg:hidden px-2"
    >
      <div class="flex-none">
        <label for="my-drawer-2" class="btn btn-ghost btn-sm px-2" [attr.aria-label]="t('nav.openNavigation')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class="inline-block w-5 h-5 stroke-current"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            ></path>
          </svg>
        </label>
      </div>
      <div class="flex-1">
        <span class="text-heading-md">{{ t('nav.appTitle') }}</span>
      </div>
    </div>

    <main class="flex-1 overflow-y-auto page-padding bg-background">
      <router-outlet></router-outlet>
    </main>
  </div>

  <div class="drawer-side">
    <label
      for="my-drawer-2"
      [attr.aria-label]="t('nav.closeSidebar')"
      class="drawer-overlay"
    ></label>
    <app-sidebar class="w-50 h-full"></app-sidebar>
  </div>
</div>
